import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false
};

export const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    startLoading: (state) => {
      state.loading = true;
    },
    stopLoading: (state) => {
      state.loading = false;
    }
  }
});

export const loadingActions = loadingSlice.actions;
